import { useTranslation } from 'react-i18next';
import { Button, InputPlain } from '@peacecover/component';
import { SnsX, SnsInsta } from '@peacecover/icon';

interface SnsInputBoxProps {
  snsType: 'instagram' | 'twitter';
  account: string;
  isCheckDuplicate: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCheckDuplicate: () => void;
  className?: string;
}

const SnsInputBox = ({
  snsType,
  account,
  isCheckDuplicate,
  onChange,
  onCheckDuplicate,
  className = ''
}: SnsInputBoxProps) => {
  const { t } = useTranslation();
  return (
    <div className={`flex flex-col items-start gap-[16px] ${className}`}>
      <div className="flex items-center gap-[6px]">
        {snsType === 'instagram' ? (
          <SnsInsta size={18} className="text-text-main-lv2" />
        ) : (
          <SnsX size={18} className="text-text-main-lv2" />
        )}
        <p className="text-[17px] font-semibold leading-[20px] text-text-main-lv2">
          {snsType === 'instagram' ? t('FanBuddySetting.instagram') : t('FanBuddySetting.twitter')}
        </p>
      </div>
      <div className="rounded-[12px] bg-secondary-light dark:bg-secondary-dark flex items-center justify-between px-[16px] py-[13px] w-full">
        <InputPlain
          className="bg-transparent border-none"
          placeholder={t('FanBuddySetting.enterAccounts') as string}
          value={account}
          onChange={onChange}
        />
        <Button
          size="small"
          className="text-[13px] whitespace-nowrap px-[12px] font-medium"
          disabled={account.length === 0 || isCheckDuplicate}
          onClick={onCheckDuplicate}
        >
          {t('FanBuddySetting.checkDuplicate')}
        </Button>
      </div>
    </div>
  );
};

export default SnsInputBox;
